export default function getContentFromElementById(id) {
    const areaEl = document.getElementById(id);
    const text = (areaEl === null || areaEl === void 0 ? void 0 : areaEl.innerText) || '';
    return text;
}
